import React from 'react';

import { PopupEntryPoint } from '../shared/popup-entry-point';

import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint } from './entrypoint';

export function PaymentDetailsPopupDialog() {
	return (
		<PopupEntryPoint
			entryPoint={entryPoint}
			placement={'bottom-start'}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
}
